import React from "react";
import { useGetAllCategoriesQuery, useGetMainCategoriesQuery } from "../../../providers/categories";
import { CategoriesSkeleton } from "./components/CategoriesSkeleton";
import { CategoryList } from "./components/CategoryList";
import { ProductsSearchPageLayout } from "../../../components/ProductsSearchPageLayout/ProductsSearchPageLayout";
import { useTranslation } from "react-i18next";

const SearchMainCategories = () => {
  const { t } = useTranslation();
  const { data: mainCategories, isLoading: isMainCatLoading } = useGetMainCategoriesQuery();
  const { data: { allCategories } = {}, isLoading: isAllCatLoading } = useGetAllCategoriesQuery();

  const isLoading = isAllCatLoading || isMainCatLoading;

  return (
    <ProductsSearchPageLayout
      pageTitle={t("Catalog")}
      breadcrumbsTitle={t("Catalog")}
      showHeaderDesktop={false}
      showTitlePage={false}
      showContentFooter={false}
      hideResultsOnMdUp={false}
      hideChildrenOnMdUp={true}
      autofocus
    >
      {isLoading ? (
        <CategoriesSkeleton />
      ) : (
        !!mainCategories?.length && (
          <CategoryList
            allCategories={allCategories ?? []}
            mainCategories={mainCategories ?? []}
          />
        )
      )}
    </ProductsSearchPageLayout>
  );
};

export default SearchMainCategories;
